/* Do Me — motion engine. Lenis inertia scroll, one scroll-linked rAF loop, the travelling muse, the light, the range camera move. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  var easeInOut = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  /* ---------- age gate ---------- */
  var gateOpen = true;
  (function gate() {
    var g = document.getElementById('dmGate'); if (!g) return;
    var ok = false; try { ok = localStorage.getItem('dm_18') === '1'; } catch (e) {}
    if (ok) { g.hidden = true; return; }
    gateOpen = false;
    document.body.classList.add('dm-lock'); g.hidden = false;
    var yes = g.querySelector('[data-gate-yes]'); yes && yes.focus({ preventScroll: true });
    g.addEventListener('click', function (e) {
      if (e.target.closest('[data-gate-yes]')) {
        try { localStorage.setItem('dm_18', '1'); } catch (err) {}
        g.classList.add('is-leaving'); document.body.classList.remove('dm-lock'); gateOpen = true;
        setTimeout(function () { g.hidden = true; }, 520);
        document.dispatchEvent(new CustomEvent('dm:enter'));
      }
      if (e.target.closest('[data-gate-no]')) window.location.href = 'https://www.google.com';
    });
  })();

  /* ---------- scroll source ---------- */
  var velocity = 0, lenis = null;
  if (window.Lenis && !reduce) {
    lenis = new window.Lenis({ lerp: 0.09, smoothWheel: true, syncTouch: false });
    lenis.on('scroll', function (e) { velocity = e.velocity; });
    window.dmLenis = lenis;
  } else {
    var lastNative = window.scrollY;
    window.addEventListener('scroll', function () { velocity = window.scrollY - lastNative; lastNative = window.scrollY; }, { passive: true });
  }
  function scrollTo(y, opts) {
    if (lenis) lenis.scrollTo(y, Object.assign({ duration: 1, easing: function (t) { return 1 - Math.pow(1 - t, 4); } }, opts || {}));
    else window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a || a.getAttribute('href').length < 2) return;
    var t = document.querySelector(a.getAttribute('href')); if (!t) return;
    e.preventDefault(); scrollTo(t.getBoundingClientRect().top + window.scrollY);
  });

  /* ---------- the frame loop ---------- */
  var scrubs = [];
  function onScrub(fn) { scrubs.push(fn); }
  var vh = window.innerHeight, vw = window.innerWidth;
  window.addEventListener('resize', function () { vh = window.innerHeight; vw = window.innerWidth; });
  var pointer = { x: vw / 2, y: vh / 2, tx: vw / 2, ty: vh / 2 };
  if (fine) window.addEventListener('pointermove', function (e) { pointer.tx = e.clientX; pointer.ty = e.clientY; }, { passive: true });
  var t0 = performance.now(), lastT = t0;
  function frame(now) {
    if (lenis) lenis.raf(now);
    var dt = Math.min(50, now - lastT); lastT = now;
    pointer.x = lerp(pointer.x, pointer.tx, .08); pointer.y = lerp(pointer.y, pointer.ty, .08);
    for (var i = 0; i < scrubs.length; i++) scrubs[i](now - t0, dt);
    velocity *= .82;
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  /* ---------- cursor light ---------- */
  (function cursorLight() {
    var el = document.querySelector('.dm-cursorlight'); if (!el) return;
    if (!fine || reduce) { el.remove(); return; }
    onScrub(function () { el.style.transform = 'translate3d(' + (pointer.x - 300).toFixed(1) + 'px,' + (pointer.y - 300).toFixed(1) + 'px,0)'; });
  })();

  /* ---------- reveals + kinetic type ---------- */
  document.querySelectorAll('[data-split]').forEach(function (h) {
    if (h.dataset.splitDone) return; h.dataset.splitDone = '1';
    var nodes = Array.prototype.slice.call(h.childNodes), i = 0;
    h.textContent = '';
    nodes.forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (w) {
          if (!w) return;
          if (/^\s+$/.test(w)) { h.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span'); s.className = 'dm-w'; s.style.setProperty('--i', i++); s.textContent = w; h.appendChild(s);
        });
      } else if (n.nodeType === 1) { var wrap = n.cloneNode(true); wrap.classList.add('dm-w'); wrap.style.setProperty('--i', i++); h.appendChild(wrap); }
    });
  });
  (function reveals() {
    var els = document.querySelectorAll('.dm-reveal,[data-split]'); if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- parallax ---------- */
  (function parallax() {
    var els = document.querySelectorAll('[data-parallax]'); if (!els.length || reduce) return;
    onScrub(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > vh + 200) return;
        var c = (r.top + r.height / 2) - vh / 2;
        el.style.transform = 'translate3d(0,' + (-c * parseFloat(el.dataset.parallax)).toFixed(1) + 'px,0)' + (el.dataset.parallaxRotate ? ' rotate(' + (c * parseFloat(el.dataset.parallaxRotate) / 100).toFixed(2) + 'deg)' : '');
      });
    });
  })();


  /* ---------- product photos move with the scroll: each print drifts, turns and settles as it crosses the screen ---------- */
  (function productMotion() {
    if (reduce) return;
    var imgs = Array.prototype.slice.call(document.querySelectorAll('.dm-photo img')).filter(function (i) { return !i.closest('[data-strip-item]'); });
    if (!imgs.length) return;
    var items = imgs.map(function (img, i) { return { img: img, box: img.parentNode, phase: (i % 5) - 2, cur: 0, tgt: 0, sc: 1, tsc: 1 }; });
    onScrub(function () {
      var vh = window.innerHeight;
      for (var i = 0; i < items.length; i++) {
        var it = items[i], r = it.box.getBoundingClientRect();
        if (r.bottom < -vh * .5 || r.top > vh * 1.5) continue;
        var t = clamp((r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2), -1, 1);
        it.tgt = t; it.cur = lerp(it.cur, it.tgt, .12);
        var y = it.cur * -22 * (1 + it.phase * .12);
        it.img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      }
    });
  })();

  /* ---------- 3D tilt ---------- */
  (function tilt() {
    if (!fine || reduce) return;
    document.querySelectorAll('[data-tilt]').forEach(function (el) {
      var rx = 0, ry = 0, tx = 0, ty = 0, inside = false, amt = parseFloat(el.dataset.tilt || '10');
      el.addEventListener('pointerenter', function () { inside = true; });
      el.addEventListener('pointerleave', function () { inside = false; tx = 0; ty = 0; });
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); tx = ((e.clientY - r.top) / r.height - .5) * -amt; ty = ((e.clientX - r.left) / r.width - .5) * amt; });
      onScrub(function () {
        if (!inside && Math.abs(rx) < .05 && Math.abs(ry) < .05) return;
        rx = lerp(rx, tx, .12); ry = lerp(ry, ty, .12);
        el.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      });
    });
  })();

  /* ---------- alpha video (stacked colour + matte, composited in WebGL) ---------- */
  function AlphaVideo(canvas) {
    var src = canvas.dataset.alphaVideo, video = document.createElement('video'), self = this;
    video.muted = true; video.playsInline = true; video.loop = false; video.preload = canvas.dataset.preload || 'auto'; video.crossOrigin = 'anonymous'; video.src = src;
    var loopFrom = parseFloat(canvas.dataset.loopFrom || '0'), loopTo = parseFloat(canvas.dataset.loopTo || '0');
    this.ready = false; this.failed = false; this.ended = false; this.canvas = canvas; this.video = video;
    var gl = canvas.getContext('webgl', { premultipliedAlpha: false, alpha: true }); if (!gl) { this.failed = true; return; }
    var vs = 'attribute vec2 p;varying vec2 v;void main(){v=vec2((p.x+1.)/2.,(1.-p.y)/2.);gl_Position=vec4(p,0.,1.);}';
    var fs = 'precision mediump float;uniform sampler2D t;varying vec2 v;void main(){vec4 c=texture2D(t,vec2(v.x,v.y*.5));float a=texture2D(t,vec2(v.x,.5+v.y*.5)).r;gl_FragColor=vec4(c.rgb,a);}';
    function sh(type, s) { var o = gl.createShader(type); gl.shaderSource(o, s); gl.compileShader(o); return o; }
    var prog = gl.createProgram(); gl.attachShader(prog, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(prog); gl.useProgram(prog);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    video.addEventListener('loadedmetadata', function () { canvas.width = video.videoWidth; canvas.height = video.videoHeight / 2; gl.viewport(0, 0, canvas.width, canvas.height); self.ready = true; });
    video.addEventListener('error', function () { self.failed = true; });
    video.addEventListener('timeupdate', function () { if (loopTo && video.currentTime >= loopTo) video.currentTime = loopFrom; });
    video.addEventListener('ended', function () { self.ended = true; if (loopTo) { video.currentTime = loopFrom; video.play(); } });
    this.draw = function () { if (!self.ready || video.readyState < 2) return; gl.bindTexture(gl.TEXTURE_2D, tex); gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); };
    this.play = function (rate) { if (rate !== undefined) video.playbackRate = clamp(rate, .1, 4); if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } };
    this.pause = function () { if (!video.paused) video.pause(); };
    this.restart = function () { video.currentTime = 0; self.ended = false; self.play(1); };
    onScrub(function () { if (!video.paused) self.draw(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) video.pause(); });
  }

  /* ---------- the travelling muse ---------- */
  /* ---------- product page: magnify inside the photo, following the cursor ---------- */
  if (fine) document.querySelectorAll('[data-zoom]').forEach(function (fig) {
    var img = fig.querySelector('img'); if (!img) return;
    fig.addEventListener('pointerenter', function () { fig.classList.add('is-zoom'); });
    fig.addEventListener('pointerleave', function () { fig.classList.remove('is-zoom'); img.style.transformOrigin = '50% 50%'; });
    fig.addEventListener('pointermove', function (e) { var r = fig.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'; });
  });

  /* ---------- the showcase wheel: products on an arc, one in the spotlight ---------- */
  document.querySelectorAll('[data-dm-wheel]').forEach(function (root) {
    var stage = root.querySelector('[data-wheel-stage]'), items = Array.prototype.slice.call(root.querySelectorAll('[data-wheel-item]'));
    var nameEl = root.querySelector('[data-wheel-name]'), subEl = root.querySelector('[data-wheel-sub]'), priceEl = root.querySelector('[data-wheel-price]'), cta = root.querySelector('[data-wheel-cta]');
    var n = items.length; if (!n) return;
    var active = Math.min(1, n - 1), pos = active, target = active, dragging = false, dragX = 0, dragStart = 0, moved = false, lastWheel = 0;
    // each product's real width, relative to its height (measured from the cut-outs)
    var CUT_W = { 'bleach-my-butt': .462, 'longer-delay-cream': .394, 'tight-as-a-virgin': .319, 'do-her': .427, 'seduce-her': .178, 'seduce-him': .231, 'restraints-set': 1.125, 'door-swing': .793, 'position-pillow': 1.712, 'sex-dice': .988 };
    function metrics() {
      var m = vw < 62 * 16, sh = stage.getBoundingClientRect().height, ih = sh * (m ? .58 : .62), maxW = m ? vw * .62 : Math.min(vw * .30, 420);
      var ws = items.map(function (it) { var r = CUT_W[it.dataset.handle] || .5; var w = ih * r, h = ih; if (w > maxW) { w = maxW; } return w; });
      return { ih: ih, ws: ws, gap: m ? sh * .09 : sh * .16, m: m };
    }
    function scaleAt(ad) { return Math.max(.6, 1 - ad * .16); }
    // row positions for an integer centre c: products are laid out edge to edge with a constant gap, scaled as they recede
    function rowFor(c, M) {
      var xs = new Array(n); xs[c] = 0;
      for (var side = -1; side <= 1; side += 2) {
        var prev = c, x = 0;
        for (var k = 1; k <= Math.floor(n / 2); k++) {
          var i = ((c + side * k) % n + n) % n, sp = scaleAt(k - 1), sk = scaleAt(k);
          x += side * (M.ws[prev] * sp / 2 + M.gap * (sp + sk) / 2 + M.ws[i] * sk / 2);
          if (xs[i] === undefined || Math.abs(x) < Math.abs(xs[i])) xs[i] = x;
          prev = i;
        }
      }
      return xs;
    }
    function place() {
      var M = metrics(), c0 = Math.floor(pos), c1 = (c0 + 1) % n, f = pos - c0, r0 = rowFor(c0, M), r1 = rowFor(c1, M);
      for (var i = 0; i < n; i++) {
        var d = i - pos; if (d > n / 2) d -= n; if (d < -n / 2) d += n;
        var ad = Math.abs(d), st = items[i].style, near = Math.max(0, 1 - ad);
        var x = r0[i] * (1 - f) + r1[i] * f;
        var y = Math.min(ad, 3) * M.ih * .05;
        var tilt = -3 - Math.min(ad, 1) * 6 - Math.max(0, ad - 1) * 1.5; if (d < 0) tilt = -tilt;
        st.setProperty('--w', M.ws[i].toFixed(1) + 'px');
        st.setProperty('--x', x.toFixed(1) + 'px'); st.setProperty('--y', y.toFixed(1) + 'px');
        st.setProperty('--r', tilt.toFixed(2) + 'deg'); st.setProperty('--s', scaleAt(ad).toFixed(3));
        st.setProperty('--o', ad > 3.4 ? 0 : Math.min(1, 3.4 - ad).toFixed(3)); st.setProperty('--z', String(100 - Math.round(ad * 10)));
        st.setProperty('--b', (0.42 + 0.68 * Math.pow(near, 1.2)).toFixed(3)); st.setProperty('--sat', (0.8 + 0.2 * near).toFixed(3));
        st.setProperty('--near', near.toFixed(3));
        items[i].classList.toggle('is-active', i === active);
      }
    }
    function caption(i, swap) {
      var it = items[i];
      function set() { nameEl.textContent = it.dataset.title; subEl.textContent = it.dataset.sub || ''; priceEl.textContent = it.dataset.price || ''; cta.href = it.dataset.url; nameEl.classList.remove('is-swap'); }
      if (swap && !reduce) { nameEl.classList.add('is-swap'); setTimeout(set, 220); } else set();
    }
    function arrive() { stage.classList.remove('is-arrive'); void stage.offsetWidth; stage.classList.add('is-arrive'); }
    function go(i, swap) { i = ((i % n) + n) % n; if (i === active) { target = active; return; } active = i; target = i; caption(i, swap !== false); arrive(); }
    root.querySelector('[data-wheel-prev]').addEventListener('click', function () { go(active - 1); });
    root.querySelector('[data-wheel-next]').addEventListener('click', function () { go(active + 1); });
    items.forEach(function (it, i) {
      it.addEventListener('click', function (e) { if (moved) { e.preventDefault(); return; } if (i !== active) { e.preventDefault(); go(i); } });
    });
    stage.addEventListener('pointerdown', function (e) { if (e.button) return; dragging = true; moved = false; dragStart = e.clientX; dragX = pos; stage.classList.add('is-dragging'); });
    window.addEventListener('pointermove', function (e) { if (!dragging) return; var dx = e.clientX - dragStart; if (Math.abs(dx) > 6) moved = true; target = dragX - dx / (vw < 62 * 16 ? vw * .6 : Math.min(vw * .24, 340)); });
    window.addEventListener('pointerup', function () { if (!dragging) return; dragging = false; stage.classList.remove('is-dragging'); go(Math.round(target)); setTimeout(function () { moved = false; }, 50); });
    stage.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) return; e.preventDefault(); var now = performance.now(); if (now - lastWheel < 350) return; lastWheel = now; go(active + (e.deltaX > 0 ? 1 : -1)); }, { passive: false });
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { go(active + 1); e.preventDefault(); } if (e.key === 'ArrowLeft') { go(active - 1); e.preventDefault(); } });
    onScrub(function () {
      var r = root.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      // shortest way round the ring
      var d = target - pos; while (d > n / 2) d -= n; while (d < -n / 2) d += n;
      pos += d * (dragging ? .35 : .1); if (pos < 0) pos += n; if (pos >= n) pos -= n;
      place();
    });
    caption(active, false); place();
    var seen = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { arrive(); seen.disconnect(); } }); }, { threshold: .4 }); seen.observe(stage);
  });

  /* ---------- the deck: cards spread out of a stack as the pinned section scrolls ---------- */
  document.querySelectorAll('[data-dm-deck]').forEach(function (root) {
    var track = root.querySelector('[data-deck-track]'), cardsEl = root.querySelector('[data-deck-cards]'), cards = Array.prototype.slice.call(root.querySelectorAll('[data-deck-card]'));
    var nameEl = root.querySelector('[data-deck-name]'), lineEl = root.querySelector('[data-deck-line]'), nextEl = root.querySelector('[data-deck-next]');
    var n = cards.length; if (!n) return; var P = 0, shown = -1, ended = false;
    function caption(i) {
      if (i === shown) return; shown = i;
      var c = cards[i], nx = cards[(i + 1) % n];
      nameEl.classList.add('is-swap'); lineEl.classList.add('is-swap');
      setTimeout(function () { nameEl.textContent = c.dataset.title; lineEl.textContent = c.dataset.sub || ''; if (nextEl) nextEl.textContent = nx.dataset.title; nameEl.classList.remove('is-swap'); lineEl.classList.remove('is-swap'); }, reduce ? 0 : 200);
    }
    function place() {
      var m = vw < 62 * 16, area = cardsEl.getBoundingClientRect().height, w = Math.min(area * .98, m ? Math.min(vw * .6, 320) : Math.min(vw * .36, 520));
      cardsEl.style.setProperty('--cw', w.toFixed(1) + 'px');
      for (var i = 0; i < n; i++) {
        var d = i - P, ad = Math.abs(d), sg = d < 0 ? -1 : 1, st = cards[i].style, x, ry, zz, sc, o;
        if (ad < 1) { // moving into / out of the front slot: blend from the side pose to flat centre
          var side = ad; x = sg * side * w * .62; ry = -sg * side * 52; zz = -side * 40; sc = 1 - side * .06;
        } else { x = sg * (w * .62 + (ad - 1) * w * .30); ry = -sg * 52; zz = -40 - (ad - 1) * 24; sc = .94 - (ad - 1) * .03; }
        o = ad > 4.5 ? 0 : 1;
        st.setProperty('--x', x.toFixed(1) + 'px'); st.setProperty('--ry', ry.toFixed(2) + 'deg'); st.setProperty('--zz', zz.toFixed(1) + 'px'); st.setProperty('--s', sc.toFixed(3)); st.setProperty('--o', String(o)); st.setProperty('--z', String(100 - Math.round(ad * 10)));
      }
      caption(clamp(Math.round(P), 0, n - 1));
      if (!ended && P > n - 1.15) { ended = true; document.dispatchEvent(new CustomEvent('dm:deck-end')); }
    }
    var target = 0;
    onScrub(function () {
      var rct = track.getBoundingClientRect(); if (rct.bottom < 0 || rct.top > vh) return;
      var total = rct.height - vh; target = clamp(-rct.top / total, 0, 1) * (n - 1);
      P = lerp(P, target, reduce ? 1 : .14); place();
    });
    place();
  });

  /* ---------- email popup: once per week, after the visitor has settled in ---------- */
  (function popup() {
    var pop = document.getElementById('dmPop'); if (!pop) return;
    var KEY = 'dmPopSubscribed', video = pop.querySelector('[data-pop-video]'), shown = false;
    // shows on every page load; only a completed sign-up stops it
    function seen() { try { return !!localStorage.getItem(KEY); } catch (e) { return false; } }
    function mark() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function open() {
      if (shown || seen()) return; shown = true;
      pop.hidden = false; void pop.offsetWidth; pop.classList.add('is-on'); document.body.classList.add('dm-lock');
      if (video && !reduce) { video.src = video.dataset.src; video.loop = false; var p = video.play(); if (p && p.catch) p.catch(function () {}); video.onended = function () { video.pause(); }; }
    }
    function close() { pop.classList.remove('is-on'); document.body.classList.remove('dm-lock'); setTimeout(function () { pop.hidden = true; if (video) video.pause(); }, 350); }
    pop.querySelectorAll('[data-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    var form = pop.querySelector('form'); if (form) form.addEventListener('submit', function () { mark(); });
    // opens once the visitor has scrolled through the whole deck (the last product has come to the front)
    document.addEventListener('dm:deck-end', function () { setTimeout(open, 900); });
  })();

  /* ---------- search overlay ---------- */
  (function search() {
    var box = document.querySelector('[data-dm-search]'); if (!box) return;
    var input = box.querySelector('[data-dm-search-input]'), openers = document.querySelectorAll('[data-dm-search-open]');
    function open() { box.hidden = false; void box.offsetWidth; box.classList.add('is-on'); openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); }); setTimeout(function () { input.focus(); }, 120); }
    function close() { box.classList.remove('is-on'); openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); }); setTimeout(function () { box.hidden = true; }, 400); }
    openers.forEach(function (o) { o.addEventListener('click', function () { box.classList.contains('is-on') ? close() : open(); }); });
    box.querySelector('[data-dm-search-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-on')) close(); });
    document.addEventListener('click', function (e) { if (box.classList.contains('is-on') && !box.contains(e.target) && !e.target.closest('[data-dm-search-open]')) close(); });
  })();

  /* ---------- preview only: filter the shop grid by ?q= ---------- */
  (function localFilter() {
    var q = new URLSearchParams(location.search).get('q'); if (!q || window.Shopify) return;
    var head = document.querySelector('.dm-col__title'); if (head) head.textContent = 'Results for "' + q + '"';
    document.querySelectorAll('.dm-col__grid > li, .dm-card').forEach(function (li) { var t = (li.textContent || '').toLowerCase(); var hit = t.indexOf(q.toLowerCase()) >= 0; (li.closest('li') || li).style.display = hit ? '' : 'none'; });
  })();

  /* ---------- horizontal scrollers with arrows ---------- */
  document.querySelectorAll('[data-scroller]').forEach(function (row) {
    var wrap = row.parentElement, prev = wrap.querySelector('[data-scroll-prev]'), next = wrap.querySelector('[data-scroll-next]');
    if (!prev || !next) return;
    function step() { var t = row.firstElementChild; return t ? t.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || 0) : row.clientWidth; }
    function sync() { prev.disabled = row.scrollLeft <= 2; next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2; }
    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
  });

  /* ---------- dock: an element that follows a point on an image (the email field on her fingertip) ---------- */
  (function dockTo() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-dock-to]')); if (!els.length) return;
    onScrub(function () {
      for (var i = 0; i < els.length; i++) {
        var f = els[i];
        if (vw < 62 * 16) { if (f.style.cssText) f.style.cssText = ''; continue; }
        var img = document.querySelector(f.dataset.dockTo), host = f.offsetParent; if (!img || !host) continue;
        var ir = img.getBoundingClientRect(), hr = host.getBoundingClientRect();
        if (!ir.width) continue;
        var x = ir.left - hr.left + parseFloat(f.dataset.ax || '.5') * ir.width + parseFloat(f.dataset.gap || '10');
        var a = f.dataset.dockAnchor ? f.querySelector(f.dataset.dockAnchor) : null, aTop = a ? a.offsetTop : 0, aH = a ? a.offsetHeight : f.offsetHeight;
        var y = ir.top - hr.top + parseFloat(f.dataset.ay || '.5') * ir.height - aTop - aH / 2;
        var maxX = hr.width - f.offsetWidth - 8; if (x > maxX) x = maxX;
        // not enough room above the fingertip for the copy: move her down instead of clipping the headline
        var minTop = parseFloat(f.dataset.minTop || '28');
        if (y < minTop) { var dy = (parseFloat(img.dataset.shift || '0') + (minTop - y)); img.dataset.shift = dy.toFixed(1); img.style.transform = 'translateY(' + dy.toFixed(1) + 'px)'; y = minTop; }
        else if (img.dataset.shift && parseFloat(img.dataset.shift) > 0 && y - minTop > 1) { var back = Math.min(parseFloat(img.dataset.shift), y - minTop); var ns = parseFloat(img.dataset.shift) - back; img.dataset.shift = ns.toFixed(1); img.style.transform = ns > 0 ? 'translateY(' + ns.toFixed(1) + 'px)' : ''; y -= back; }
        f.style.left = x.toFixed(1) + 'px'; f.style.top = y.toFixed(1) + 'px';
      }
    });
  })();

  /* ---------- standalone alpha videos (the finale) ---------- */
  (function standaloneAlpha() {
    if (reduce) return;
    document.querySelectorAll('canvas[data-alpha-video][data-autoplay]').forEach(function (c) {
      var av = new AlphaVideo(c); if (av.failed) { c.remove(); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) av.play(1); else av.pause(); }); }, { rootMargin: '10% 0px' });
      io.observe(c);
    });
  })();

  (function museLayer() {
    var layer = document.querySelector('[data-muse-layer]'); if (!layer) return;
    if (reduce) { layer.hidden = true; return; }
    var clips = {};
    layer.querySelectorAll('canvas[data-clip]').forEach(function (c) { clips[c.dataset.clip] = { el: c, av: new AlphaVideo(c) }; });
    var still = layer.querySelector('[data-muse-still]');
    var stations = Array.prototype.slice.call(document.querySelectorAll('[data-muse]'));
    if (!stations.length) { layer.hidden = true; return; }
    var state = { x: vw * .7, h: vh * .8, flip: 1, op: 0 }, target = { x: vw * .7, h: vh * .8, flip: 1, op: 1 };
    var current = null, heroDone = false, kissUntil = 0, vel = 0;
    var mobile = function () { return vw < 62 * 16; };
    function usable(name) { var c = clips[name]; return c && !c.av.failed; }
    function show(name) {
      if (current === name) return;
      Object.keys(clips).forEach(function (k) { var c = clips[k]; var on = k === name; c.el.classList.toggle('is-on', on); if (!on) c.av.pause(); });
      current = name;
      if (usable(name)) { if (name === 'walkin' || name === 'tease') clips[name].av.restart(); else clips[name].av.play(1); if (still) still.classList.remove('is-on'); }
      else if (still) still.classList.add('is-on');
    }
    function stationAt() {
      var mid = vh * .5;
      for (var i = 0; i < stations.length; i++) { var r = stations[i].getBoundingClientRect(); if (r.top <= mid && r.bottom >= mid) return stations[i]; }
      return null;
    }
    document.addEventListener('dm:enter', function () { if (!heroDone) show('walkin'); });
    document.addEventListener('dm:added', function () { kissUntil = performance.now() + 2400; });
    onScrub(function (now) {
      var s = stationAt(), mode = s ? s.dataset.muse : 'hide', side = s && s.dataset.museSide === 'left' ? -1 : 1, m = mobile();
      var H = m ? vh * .34 : vh * .76, X = side > 0 ? vw * (m ? .64 : .72) : vw * (m ? .06 : .08), F = side > 0 ? 1 : -1, OP = 1, clip = 'idle', Y = 0;
      if (mode === 'hero') { clip = heroDone ? 'idle' : 'walkin'; H = m ? vh * .36 : Math.min(vh * .72, vw * .42); X = m ? vw * .5 : vw * .76; F = 1; Y = m ? -vh * .42 : -vh * .16; }
      else if (mode === 'point') { clip = 'point'; H = m ? vh * .24 : vh * .33; X = side > 0 ? vw * (m ? .9 : .95) : vw * (m ? .12 : .1); F = side > 0 ? -1 : 1; }
      else if (mode === 'peek') { clip = 'beckon'; H = m ? vh * .3 : vh * .56; X = side > 0 ? vw * (m ? .96 : .985) : vw * .02; F = side > 0 ? -1 : 1; }
      else if (mode === 'kiss') { clip = usable('tease') ? 'tease' : 'kiss'; H = vh * .64; X = side > 0 ? vw * .8 : vw * .12; F = 1; Y = -vh * .04; }
      else if (mode === 'walk') { clip = 'walkcycle'; H = m ? vh * .3 : vh * .5; X = side > 0 ? vw * (m ? .9 : .95) : vw * .06; F = -1; }
      else if (mode === 'hide') { OP = 0; H = state.h; X = state.x; Y = state.y || 0; clip = current || 'idle'; }
      if (m && (mode === 'point' || mode === 'walk' || mode === 'kiss')) OP = 0;
      if (clip === 'walkin' && usable('walkin') && clips.walkin.av.ended) { heroDone = true; clip = 'idle'; }
      if (!gateOpen) clip = current || 'walkin';
      // between stations she walks, at the speed you scroll
      if (kissUntil > now && usable('kiss')) clip = 'kiss';
      if (mode !== 'hero' && mode !== 'kiss') OP = 0;
      if (!usable(clip)) clip = usable('idle') ? 'idle' : (usable('walkin') ? 'walkin' : 'still');
      show(clip);
      state.x = lerp(state.x, X, .06); state.h = lerp(state.h, H, .06); state.op = lerp(state.op, OP, OP === 0 ? .22 : .14); state.flip = F; state.y = lerp(state.y || 0, Y, .06);
      var dx = fine ? (pointer.x / vw - .5) * 18 : 0, dy = fine ? (pointer.y / vh - .5) * 10 : 0;
      layer.style.transform = 'translate3d(' + (state.x + dx).toFixed(1) + 'px,' + (state.y + dy).toFixed(1) + 'px,0)';
      layer.style.height = state.h.toFixed(1) + 'px'; layer.style.opacity = state.op.toFixed(3);
      layer.style.setProperty('--flip', state.flip.toFixed(3));
      var hidden = state.op < .02; layer.classList.toggle('is-hidden', hidden);
      if (hidden && current && clips[current]) clips[current].av.pause(); else if (!hidden && current && clips[current] && usable(current)) clips[current].av.play();
    });
  })();

  /* ---------- films: play when in view, lazy source ---------- */
  function filmPlay(f) { var v = f.querySelector('video'); if (!v) return; if (!v.dataset.loaded) { v.src = v.dataset.src; v.dataset.loaded = '1'; } var p = v.play(); if (p && p.catch) p.catch(function () {}); f.classList.add('is-playing'); }
  function filmPause(f) { var v = f.querySelector('video'); if (v && !v.paused) v.pause(); }
  document.querySelectorAll('.dm-film[data-autoplay]').forEach(function (f) {
    var io = new IntersectionObserver(function (en) { en[0].isIntersecting ? filmPlay(f) : filmPause(f); }, { rootMargin: '10% 0px' }); io.observe(f);
  });

  /* ---------- hero: entrance + scroll scrub ---------- */
  (function hero() {
    var h = document.querySelector('.dm-hero'); if (!h) return;
    var copy = h.querySelector('.dm-hero__copy'), word = h.querySelector('.dm-hero__word'), satin = h.querySelector('.dm-satin');
    var start = function () { h.classList.add('is-ready'); };
    if (!gateOpen) document.addEventListener('dm:enter', start, { once: true }); else setTimeout(start, 80);
    if (reduce) return;
    onScrub(function () {
      var r = h.getBoundingClientRect(); if (r.bottom < 0) return;
      var p = clamp(-r.top / (r.height * .9), 0, 1), e = easeOut(p);
      if (copy) { copy.style.transform = 'translate3d(0,' + (-e * 160).toFixed(1) + 'px,0)'; copy.style.opacity = (1 - p * 1.8).toFixed(3); }
      if (word) { word.style.fontStretch = (62 + e * 63).toFixed(1) + '%'; word.style.letterSpacing = (.02 + e * .18).toFixed(3) + 'em'; word.style.transform = 'translate3d(0,' + (e * 60).toFixed(1) + 'px,0)'; word.style.opacity = (1 - clamp((p - .5) * 2.5, 0, 1)).toFixed(3); word.style.filter = 'blur(' + (e * 12).toFixed(1) + 'px)'; }
      if (satin) satin.style.transform = 'translate3d(0,' + (e * 120).toFixed(1) + 'px,0) scale(' + (1 + e * .08).toFixed(3) + ')';
    });
  })();

  /* ---------- the range: a camera move through the films, a stop on each ---------- */
  document.querySelectorAll('[data-dm-range]').forEach(function (range) {
    var beats = range.querySelectorAll('[data-beat]'), track = range.querySelector('[data-range-track]'), light = range.querySelector('.dm-light'), dots = range.querySelectorAll('[data-beat-jump]');
    var n = beats.length; if (!n) return;
    var active = -1, lastMove = 0, snapping = false, lastY = -1;
    var parts = Array.prototype.map.call(beats, function (b) { return { el: b, stage: b.querySelector('.dm-beat__stage'), film: b.querySelector('.dm-film'), word: b.querySelector('.dm-beat__word'), card: b.querySelector('.dm-beat__card') }; });
    function beatTop(i) { var r = track.getBoundingClientRect(); var total = r.height - vh; return window.scrollY + r.top + total * i / (n - 1) + 1; }
    function apply(P) {
      var i = clamp(Math.round(P), 0, n - 1);
      if (i !== active) {
        active = i;
        beats.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-hidden', String(k !== i)); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        parts.forEach(function (p, k) { if (!p.film) return; Math.abs(k - i) <= 1 ? filmPlay(p.film) : filmPause(p.film); });
      }
      parts.forEach(function (b, k) {
        var l = P - k, vis = Math.abs(l) < 1.05;
        b.el.style.visibility = vis ? 'visible' : 'hidden'; if (!vis) return;
        var s, y, bl, o, br;
        if (l < 0) { var t = easeOut(1 + l); s = .4 + .6 * t; y = (1 - t) * 120; bl = (1 - t) * 14; o = clamp(t * 1.6, 0, 1); br = .35 + .65 * t; }
        else { var u = easeInOut(l); s = 1 + u * 1.1; y = -u * 160; bl = u * 18; o = 1 - clamp(l * 1.5, 0, 1); br = 1 - u * .6; }
        b.stage.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(' + s.toFixed(3) + ')'; b.stage.style.filter = 'blur(' + bl.toFixed(1) + 'px) brightness(' + br.toFixed(2) + ')'; b.stage.style.opacity = o.toFixed(3);
        var c = clamp(1 - Math.abs(l) * 2.4, 0, 1); b.card.style.opacity = c.toFixed(3); b.card.style.transform = 'translate3d(0,' + (l * 70).toFixed(1) + 'px,0)';
        if (b.word) { b.word.style.opacity = clamp(1 - Math.abs(l) * 1.6, 0, 1).toFixed(3); b.word.style.letterSpacing = (-.06 + l * .16).toFixed(3) + 'em'; b.word.style.transform = 'translate(-50%,-50%) translate3d(' + (-l * 12).toFixed(1) + 'vw,0,0)'; }
      });
      if (light) { var f = P - Math.round(P); light.style.transform = 'translate(-50%,-50%) translate3d(' + (f * 220).toFixed(1) + 'px,' + (Math.abs(f) * -120).toFixed(1) + 'px,0) scale(' + (1 - Math.abs(f) * .35).toFixed(3) + ')'; }
    }
    function progress() { var r = track.getBoundingClientRect(); var total = r.height - vh; return clamp(-r.top / total, 0, 1) * (n - 1); }
    onScrub(function () {
      var r = track.getBoundingClientRect(); if (r.bottom < -vh || r.top > vh * 2) { if (active !== -1) { parts.forEach(function (p) { if (p.film) filmPause(p.film); }); active = -1; } return; }
      apply(progress());
      if (reduce) return;
      var y = window.scrollY;
      if (Math.abs(y - lastY) > .5) { lastMove = performance.now(); snapping = false; }
      lastY = y;
      var inside = r.top < -2 && r.bottom > vh + 2;
      if (inside && !snapping && performance.now() - lastMove > 160) { var tgt = beatTop(Math.round(progress())); if (Math.abs(tgt - y) > 6) { snapping = true; scrollTo(tgt, { duration: .9 }); } }
    });
    dots.forEach(function (d) { d.addEventListener('click', function () { snapping = true; scrollTo(beatTop(parseInt(d.dataset.beatJump, 10)), { duration: 1.1 }); }); });
  });


  /* ---------- the range strip: nine photos glide across while the stage pins ---------- */
  document.querySelectorAll('[data-dm-strip]').forEach(function (strip) {
    var track = strip.querySelector('[data-strip-track]'), rail = strip.querySelector('[data-strip-rail]'), bar = strip.querySelector('[data-strip-progress]');
    if (!track || !rail) return;
    var x = 0, items = Array.prototype.slice.call(rail.querySelectorAll('[data-strip-item]')).map(function (el) { return { el: el, img: el.querySelector('.dm-photo img') }; });
    onScrub(function () {
      var r = track.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var total = r.height - vh; var p = clamp(-r.top / total, 0, 1);
      var max = Math.max(0, rail.scrollWidth - vw + parseFloat(getComputedStyle(rail).paddingLeft) * 2);
      x = lerp(x, -p * max, reduce ? 1 : .12);
      rail.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      if (reduce) return;
      for (var i = 0; i < items.length; i++) {
        var it = items[i], b = it.el.getBoundingClientRect();
        if (b.right < -vw * .3 || b.left > vw * 1.3) continue;
        var u = clamp((b.left + b.width / 2 - vw / 2) / (vw * .5), -1.6, 1.6);
        var near = 1 - Math.min(1, Math.abs(u));
        it.el.style.transform = 'perspective(1400px) translate3d(0,' + ((1 - near) * 22).toFixed(1) + 'px,0) rotateY(' + (-u * 5).toFixed(2) + 'deg)';
        it.img.style.transform = 'translate3d(' + (-u * 26).toFixed(1) + 'px,0,0) scale(' + (1.0 + near * .1).toFixed(3) + ')';
        it.el.style.opacity = (0.55 + near * .45).toFixed(3);
      }
    });
  });

  /* ---------- marquee ---------- */
  document.querySelectorAll('[data-dm-marquee]').forEach(function (m) {
    var inner = m.querySelector('.dm-marquee__inner'), x = 0, skew = 0, dir = m.dataset.dir === 'rtl' ? -1 : 1, base = parseFloat(m.dataset.speed || '.6');
    var w = inner.scrollWidth / 2; window.addEventListener('resize', function () { w = inner.scrollWidth / 2; });
    onScrub(function () {
      var r = m.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      var v = reduce ? 0 : clamp(velocity, -60, 60);
      x -= dir * (base + Math.abs(v) * .12) * (reduce ? 0 : 1); if (x <= -w) x += w; if (x > 0) x -= w;
      skew = lerp(skew, -v * .15, .1);
      inner.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0) skewX(' + skew.toFixed(2) + 'deg)';
    });
  });

  /* ---------- magnetic buttons ---------- */
  if (fine && !reduce) document.querySelectorAll('[data-magnetic]').forEach(function (b) {
    var tx = 0, ty = 0, cx = 0, cy = 0, on = false;
    b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); tx = (e.clientX - r.left - r.width / 2) * .24; ty = (e.clientY - r.top - r.height / 2) * .24; on = true; });
    b.addEventListener('pointerleave', function () { tx = 0; ty = 0; });
    onScrub(function () { if (!on) return; cx = lerp(cx, tx, .16); cy = lerp(cy, ty, .16); b.style.transform = 'translate(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px)'; if (!tx && !ty && Math.abs(cx) < .05 && Math.abs(cy) < .05) on = false; });
  });

  /* ---------- hearts on add to bag ---------- */
  (function hearts() {
    var h = document.getElementById('dmHearts'); if (!h) return;
    document.addEventListener('dm:added', function () {
      if (reduce) return;
      var layer = document.querySelector('[data-muse-layer]'); var r = layer ? layer.getBoundingClientRect() : { left: vw - 120, top: vh * .5, width: 100, height: 200 };
      h.style.transform = 'translate3d(' + (r.left + r.width * .5).toFixed(0) + 'px,' + (r.top + r.height * .22).toFixed(0) + 'px,0)';
      for (var i = 0; i < 9; i++) (function () {
        var el = document.createElement('span'); el.textContent = '♥'; el.style.fontSize = (12 + Math.random() * 14) + 'px'; h.appendChild(el);
        var vx = (Math.random() - .5) * 160, vy = -(70 + Math.random() * 140), st = null;
        (function f(ts) { if (!st) st = ts; var p = (ts - st) / 1100; if (p >= 1) { el.remove(); return; } el.style.transform = 'translate(' + vx * p + 'px,' + (vy * p + 90 * p * p) + 'px)'; el.style.opacity = String(1 - p); requestAnimationFrame(f); })(performance.now());
      })();
    });
  })();

  function setCount(n) { document.querySelectorAll('[data-dm-cart-count]').forEach(function (c) { c.textContent = String(n); c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); setTimeout(function () { c.classList.remove('is-bump'); }, 400); }); }
  /* ---------- preview only: show the stored cart count on load ---------- */
  if (!window.Shopify) { try { var pc = JSON.parse(localStorage.getItem('dmPreviewCart') || '[]'); var n0 = pc.reduce(function (a, i) { return a + i.qty; }, 0); document.querySelectorAll('[data-dm-cart-count]').forEach(function (c) { c.textContent = String(n0); }); } catch (e) {} }
  /* ---------- Shopify: the header cart button opens the drawer when the theme has one ---------- */
  document.querySelectorAll('.dm-nav__bag').forEach(function (a) { a.addEventListener('click', function (e) { var d = document.querySelector('cart-drawer'); if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); } }); });

  /* ---------- add to bag via Shopify AJAX ---------- */
  document.querySelectorAll('form[data-dm-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.routes || !window.routes.cart_add_url) {
        e.preventDefault(); document.dispatchEvent(new CustomEvent('dm:added'));
        try {
          var cart = JSON.parse(localStorage.getItem('dmPreviewCart') || '[]'), key = form.dataset.url || form.dataset.title, hit = cart.filter(function (i) { return i.key === key; })[0];
          if (hit) hit.qty += 1; else cart.push({ key: key, title: form.dataset.title, price: form.dataset.price, image: form.dataset.image, url: form.dataset.url, qty: 1 });
          localStorage.setItem('dmPreviewCart', JSON.stringify(cart)); setCount(cart.reduce(function (a, i) { return a + i.qty; }, 0));
        } catch (err) { setCount((+((document.querySelector('[data-dm-cart-count]') || {}).textContent) || 0) + 1); }
        return;
      }
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.classList.add('is-loading'); btn.disabled = true;
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('dm:added'));
          return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            setCount(cart.item_count);
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.renderContents === 'function') fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) { drawer.renderContents({ sections: s }); });
          });
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    });
  });
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-dm-q]'); if (!q) return;
    var inp = q.closest('.dm-qty').querySelector('input'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.dmQ, 10));
  });

  /* ---------- nav ---------- */
  (function nav() {
    var n = document.querySelector('[data-dm-nav]'); if (!n) return;
    var last = 0;
    onScrub(function () { var y = window.scrollY; if (y === last) return; n.classList.toggle('is-scrolled', y > 24); last = y; });
    var burger = n.querySelector('[data-dm-burger]'), menu = document.querySelector('[data-dm-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () { var open = !n.classList.contains('is-open'); n.classList.toggle('is-open', open); menu.classList.toggle('is-open', open); burger.setAttribute('aria-expanded', String(open)); document.body.classList.toggle('dm-lock', open); if (lenis) open ? lenis.stop() : lenis.start(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && n.classList.contains('is-open')) burger.click(); });
    }
  })();
})();
